<template>
  <div v-background-image="banner" class="py10 background">
    <p class="h4 weight-700 px40 my10 summary-partner pointer align-center cl-white" @click="changeStore(group.partner)">
      <span class="underline relative medium">{{ group.partner.name }}</span>
      <br />
      <span class="cl-error minimal-order-amount-notice"
            v-if="group.partner.minimal_order_amount && group.partner.minimal_order_amount > group.subtotal">
          {{ '(' + $t('Minimal order amount is ') + group.partner.minimal_order_amount + $t('UAH') + ')' }}
      </span>
      <span class="cl-error minimal-order-amount-notice"
            v-if="!(group.partner.active && group.partner.enabled)">
          {{ $t('This partner is not available') }}
      </span>
    </p>
    <div class="summary px40 cl-white serif my10 ">
      <div class="row weight-700 middle-xs mb10">
        <div class="col-xs inline-flex fs16 total-price-label">
          {{ $t('In the amount of') }}
          <span class="separator col-xs ml10"></span>
        </div>
        <div class="align-right fs16 weight-700 total-price-value bold"
             :class="{'cl-error': (group.partner.minimal_order_amount && group.partner.minimal_order_amount > group.subtotal)}"
        >
          {{ group.subtotal | price }}
        </div>
      </div>
      <div class="row weight-700 middle-xs mb10">
        <div class="col-xs inline-flex fs16 total-price-label">
          {{ $t('Delivery') }}
          <span class="separator col-xs ml10"></span>
        </div>
        <div class="align-right fs16 total-price-value bold">
          <order-delivery-price :price="group.final_delivery" @add-address="handleClickAddAddress" />
        </div>
        <span class="col-xs-12 align-center" v-if="group.partner.shipping.methods.filter(method => method.method_code === 'pickup').length">
          ( {{ $t(' or free pickup') }} )
        </span>
      </div>
    </div>
  </div>

</template>

<script async>
import ClearCartButton from 'theme/components/core/blocks/Microcart/ClearCartButton'
import { mapActions } from 'vuex'
import { s3Path } from '@vue-storefront/core/helpers';
import config from 'config';
import backgroundImage from 'theme/directives/background-image';

const OrderDeliveryPrice = () => import(/* webpackChunkName: "vsf-order-delivery-price" */ 'theme/components/core/blocks/Checkout/OrderDeliveryPrice.vue');

export default {
  name: 'PartnerBanner',
  components: {
    ClearCartButton,
    OrderDeliveryPrice
  },
  props: {
    group: {
      type: Object,
      required: false
    }
  },
  directives: {
    backgroundImage
  },
  computed: {
    banner () {
      return s3Path(this.group.partner.banner)
    }
  },
  methods: {
    ...mapActions({
      ensureCurrentPartner: 'partners/ensureCurrentPartner',
      toggleMicrocart: 'ui/toggleMicrocart'
    }),
    async changeStore (store) {
      // The partner may not be loaded yet.
      await this.ensureCurrentPartner({ code: store.code, locationCode: store.location_code })
      this.$router.push({ path: `/${store.location_code}/${store.code}` })
      this.toggleMicrocart();
    },
    handleClickAddAddress () {
      this.$bus.$emit('handle-add-address-from-cart');
    }
  }
}
</script>
<style lang="scss" scoped>
.minimal-order-amount-notice {
  font-size: 14px;
}

.close {
  i {
    opacity: 0.6;
  }
  &:hover,
  &:focus {
    i {
      opacity: 1;
    }
  }
}

.mt0 {
  @media (max-width: 768px) {
    margin-top: 0;
  }
}

.clearcart {
  &-col {
    display: flex;
    align-self: center;
  }
}

.products {
  @media (max-width: 768px) {
    padding: 30px 15px;
  }
}

.actions {
  @media (max-width: 768px) {
    padding: 0 15px;
  }
  .link {
    @media (max-width: 768px) {
      display: flex;
      justify-content: center;
      padding: 20px 40px;
      &.checkout {
        margin-top: 55px;
        padding: 0;
      }
    }
  }
}

.summary {
  @media (max-width: 768px) {
    padding:  0 15px;
    font-size: 12px;
  }
}
.summary-partner{
  @media (max-width: 768px) {
    padding:  0 15px;
  }
}

.summary-heading {
  @media (max-width: 768px) {
    font-size: 18px;
  }
}

.delete-button {
  vertical-align: middle;
}

.coupon-wrapper {
  display: flex;

  .button-outline {
    text-transform: inherit;
    width: 50%;
  }

  .coupon-input {
    margin-right: 20px;
    width: 100%;
  }
}
.bg-cl-korzyna-green{
  border-radius: 10px;
}
.underline:after{
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #ffffff;
}
.summary-total{
  font-size: 21px;
}
.separator{
  border-bottom: 1px dashed #fff;
  height: 15px;
  &.bottom{
    border-bottom: 1px dashed rgba(17, 17, 17, 0.11);
  }
}
.total-price-value{
  padding-left: 8px;
  padding-right: 8px;
}
.total-price-label{
  width: calc(100% - 110px);
}
.background{
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
}

.row {
  row-gap: 6px;
}
</style>
